import { Component, inject, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { RootState } from '../../core/state/shared/root-state.interface';
import { logout } from '../../core/state/user-session/user-session.actions';
import { take } from 'rxjs';
import { selectUserData } from '../../core/state/user-session/user-session.selectors';
import { environment } from '../../../environments/environment';
import { UserSessionService } from '../../core/http/user-session.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { RouterLink } from '@angular/router';
import { DropdownComponent } from './dropdown/dropdown.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [RouterLink, DropdownComponent, SidebarComponent],
})
export class HeaderComponent implements OnInit {
  name: string;
  email: string;

  isMobile = false;
  navMenuItems: MenuItemType[] = [];
  dropdownItems: MenuItemType[] = [
    { id: 'unified-platform-app-switcher-menu-item' },
    {
      labelKey: 'home.logout',
      action: () => this.logout(),
    },
  ];

  private store = inject(Store<RootState>);
  private userSessionService = inject(UserSessionService);
  private responsiveBreakpoints = inject(BreakpointObserver);

  ngOnInit() {
    this.store
      .pipe(select(selectUserData))
      .pipe(take(1))
      .subscribe((userData) => {
        this.name = userData.name;
        this.email = userData.email;
      });

    if (!environment.production && window.unifiedPlatformScript) {
      window.unifiedPlatformScript(
        environment.appSwitcherUrl,
        this.userSessionService,
      );
    }

    this.responsiveBreakpoints
      .observe([Breakpoints.Small, Breakpoints.XSmall])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });
  }

  logout() {
    this.store.dispatch(logout({ isTimedOut: false }));
  }
}

export interface MenuItemType {
  id?: string;
  icon?: string;
  labelKey?: string;
  action?: () => void;
}
